import { IInternalOrder, IOrderShipped, IOrderStatus, IOrderWithStatus } from 'my-poppies-b2b-types';
import { memo } from 'react';

import { OrderButtonSection } from '@/components/Order/buildingBlocks/OrderButtonSection';
import { OrderInfo } from '@/components/Order/buildingBlocks/OrderInfo';
import { OrderProducts } from '@/components/Order/buildingBlocks/OrderProducts';
import { OrderShell } from '@/components/Order/buildingBlocks/OrderShell';

interface IOrderProps {
  order: Omit<IOrderWithStatus<IOrderStatus>, 'erpId'> | IOrderWithStatus<IOrderStatus> | IInternalOrder;
}

export const Order = memo(
  function Order({ order }: IOrderProps) {
    const { status, id } = order as IOrderWithStatus<IOrderStatus>;
    const { customerId } = order as IOrderShipped;

    return (
      <OrderShell>
        <OrderInfo order={order as IOrderWithStatus<IOrderStatus>} />
        <OrderProducts {...order} />
        <OrderButtonSection id={id} status={status} customerId={customerId} />
      </OrderShell>
    );
  },
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
  }
);
